

















import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';
import LocationsService from '@/api/LocationsService';
import HTTPStatus from '@/constants/httpStatus';

import ConfirmationModal from '../ConfirmationModal/ConfirmationModal.vue';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import flagKeys from '@/constants/flagKeys';
import { getBillingIsHidden } from '@/utils/billing';

@Component({
  components: {
    ConfirmationModal
  }
})
export default class DeleteLocationModal extends Vue {
  @Prop(String) locationId!: string;
  @Prop(String) locationName!: string;
  @Prop() onDeleteLocationConfirm!: (isSuccess: boolean) => void;

  locationService = new LocationsService();
  loading = false;

  // Both getters only pick which copy the confirmation carries (and the wider
  // billing layout) — the deletion itself is the same call either way. With billing
  // hidden the modal falls back to the plain "removed from all programs, campaigns
  // and Offers" wording, with no minting-plan consequence attached (TWISM-19011).
  get subscribedBilling() {
    if (getBillingIsHidden()) return false;

    return this.billingStatus === EBillingStatusTypes.SUBSCRIBED;
  }

  get delayedPeriod() {
    if (getBillingIsHidden()) return false;

    return (
      this.billingModuleV3 &&
      this.billingStatus === EBillingStatusTypes.DELAY_PERIOD
    );
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get billingModuleV3() {
    return this.flags.includes(flagKeys.billingModuleV3);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get billingStatus() {
    return this.businessInfo.subscriptionStatus;
  }

  get description() {
    if (this.subscribedBilling)
      return `You are about to delete the location<br /><span>${
        this.locationName
      }</span>.<br /><br/>This location will be removed from all programs, campaigns, and offers. Your branded Coins will no longer be minted by Twism for this location.`;

    return `You are about to delete the location<br /><span>${
      this.locationName
    }</span>.<br /><br/>This location will be removed from all programs, campaigns and Offers${
      this.delayedPeriod ? ' and disconnected from the Coin Network' : ''
    }.`;
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  async handleDeleteLocation() {
    try {
      this.loading = true;

      const { status } = await this.locationService.remove(this.locationId);

      if (status === HTTPStatus.OK) {
        this.onDeleteLocationConfirm(true);
      }
    } catch {
      this.onDeleteLocationConfirm(false);
    } finally {
      this.loading = false;
      this.onClose();
    }
  }
}
